import { Button, Divider, Heading, useMediumFromMediaQuery } from '@madpaws/design-system';
import getConfig from 'next/config';
import React, { useState } from 'react';

import { FAQs } from '~/common/components/FAQs/FAQs';

import { HowItWorks } from './HowItWorks/HowItWorks';
import { PageHead } from './PageHead';
import { ReferralForm } from './ReferralForm/ReferralForm';
import styles from './ReferralLandingPage.module.css';
import { DESCRIPTION, FAQS, HINT, TITLE } from './constants';

import type { Props } from './getServerSideProps';
import type { NextPage } from 'next';

const { publicRuntimeConfig } = getConfig();

const CAMPAIGN_ID = process.env.NEXT_PUBLIC_VIRAL_LOOPS_CAMPAIGN_ID;

export const ReferralLandingPage: NextPage<Props> = ({ userDetails }) => {
  const { email, firstName, lastName } = userDetails || {};
  const [isReferralFormVisible, setIsReferralFormVisible] = useState(false);
  const isMediumFromViewport = useMediumFromMediaQuery();
  const isReferralFormAvailable = CAMPAIGN_ID !== undefined && email;

  const showInviteLink = (): void => {
    setIsReferralFormVisible(true);
  };

  const referralForm = (): React.ReactElement =>
    isReferralFormVisible ? (
      <>
        <p className={styles.hint}>{HINT}</p>
        <ReferralForm
          campaignId={CAMPAIGN_ID || ''}
          email={email}
          firstName={firstName}
          lastName={lastName}
        />
      </>
    ) : (
      <Button
        label="Get my unique code"
        onClick={showInviteLink}
        size="default"
        variant="primary"
      />
    );

  return (
    <>
      <PageHead />
      <div className={styles.root}>
        <div className={styles.form}>
          <Heading
            fontFamily="heading"
            level={1}
            size={isMediumFromViewport ? 'large1x' : 'small1x'}
          >
            {TITLE}
          </Heading>
          <p className={styles.description}>{DESCRIPTION}</p>
          {isReferralFormAvailable ? (
            referralForm()
          ) : (
            <div>We are sorry, but the referral program is not available at that moment</div>
          )}
        </div>
        <div className={styles.image}>
          <img
            alt={'Image of Refer a friend'}
            src={`${publicRuntimeConfig.staticPath}/images/refer-a-friend.svg`}
          />
        </div>
      </div>
      <Divider />
      <HowItWorks />
      <Divider />
      <FAQs faqs={FAQS} />
    </>
  );
};
